import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "56",
  height: "56",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#CBD5E1",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "4",
  d: "M28 35h-9.333c-4.35 0-6.524 0-8.239.71a9.33 9.33 0 0 0-5.051 5.052c-.71 1.715-.71 3.89-.71 8.238M31.5 16.333a9.333 9.333 0 1 1-18.667 0 9.333 9.333 0 0 1 18.667 0M44.334 43.167 50.167 49"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "40.833",
  cy: "38.5",
  r: "5.833",
  stroke: "#CBD5E1",
  "stroke-width": "4"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#CBD5E1",
  stroke: "#CBD5E1",
  d: "M44.16 10.064c.08.053.142.136.176.235a.53.53 0 0 1 .01.309l-1.474 5.486h2.719c.08 0 .158.027.225.077a.46.46 0 0 1 .15.206.53.53 0 0 1-.077.507l-6.546 7.968a.4.4 0 0 1-.239.143.37.37 0 0 1-.264-.059.46.46 0 0 1-.176-.234.53.53 0 0 1-.01-.309l1.474-5.487h-2.719a.37.37 0 0 1-.225-.077.46.46 0 0 1-.15-.206.53.53 0 0 1 .077-.507l6.546-7.968a.4.4 0 0 1 .238-.143.37.37 0 0 1 .265.058zM37 9.45l.337.916.08.217.217.08.916.337-.916.337-.217.08-.08.217-.337.916-.337-.916-.08-.217-.217-.08L35.45 11l.916-.337.217-.08.08-.217zM45.5 22.45l.202.55.08.218.217.08.551.202-.55.202-.218.08-.08.217-.202.551-.202-.55-.08-.218-.217-.08-.551-.202.55-.202.218-.08.08-.217z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }